<!--<section class="hero" [ngStyle]="{'background-image': 'url(' + data_hero.image.url + ')'}">-->
<section class="footer" *ngIf="data_aiuppie">
  <div class="footer-title">
    <h3>{{labels?.footer?.title}}</h3>
  </div>
  <div class="footer-intro">
    <div>
      <h3 [innerHTML]="labels?.footer?.intro?.titolo"></h3>
    </div>

    <div>
      <p>
        {{labels?.footer?.intro?.testo}}
      </p>
      <a (click)="goToCheckout()">{{labels?.footer?.intro?.link}}</a>

    </div>
  </div>


  <div class="footer-info">
    <div class="footer-info-blocco">
      <h4>{{labels?.footer?.condizioni?.titolo}}</h4>
      <div [innerHTML]="labels?.footer?.condizioni?.testo"></div>
    </div>
    <div class="footer-info-blocco">
      <div class="footer-info-blocco-intro">
        <h4>{{labels?.footer?.progetto}}: {{data_aiuppie?.name}}</h4>
        <h4>{{data_aiuppie.user?.qualification}} : {{data_aiuppie?.user?.name}} {{data_aiuppie?.user?.familyName}}</h4>
        <h4 *ngIf="data_aiuppie?.buyer">{{labels?.footer?.cliente}}: {{data_aiuppie?.buyer?.name}}
          {{data_aiuppie.buyer?.familyName}}</h4>
      </div>
      <div class="footer-info-blocco-progetto">
        <div style="margin-bottom: 1rem;">
          <h4>{{labels?.footer?.progetto}}</h4>
          <ul>
            <li>
              <a (click)="scrollTo('moodboard')">{{labels?.footer?.moodboard}}</a>
            </li>
            <li>
              <a (click)="scrollTo('tuoprogetto')">{{labels?.sezioneLeftRight?.titolo}}</a>
            </li>
            <ul style="margin-left: 1rem">
              <li *ngFor="let section of data_aiuppie.scenarios[0].sections">
                <a (click)="scrollTo(section.id)">{{section.name}}</a>
                <ul style="margin-left: 1rem" *ngIf="section.childs?.length">
                  <li *ngFor="let child of section.childs">
                    <a *ngIf="child.picturesURL?.length" (click)="scrollTo(child.id)">{{child.name}}</a>
                  </li>
                </ul>
              </li>
            </ul>
            <li>
              <a (click)="scrollTo('numeri')">{{labels?.footer?.numeri}}</a>
            </li>
          </ul>
        </div>
        <div>
          <h4>{{labels?.footer?.professionista}}</h4>
          <h5>{{data_aiuppie?.user?.name}} {{data_aiuppie?.user?.familyName}}</h5>
          <p>{{data_aiuppie?.user?.company?.companyName}}</p>
          <p>{{data_aiuppie?.user?.company?.locality}}</p>
        </div>

        <div *ngIf="data_aiuppie?.advisor">
          <h4>{{labels?.footer?.advisor}}</h4>
          <h5>{{data_aiuppie.advisor.name}} {{data_aiuppie.advisor.familyName}}</h5>
          <p>{{data_aiuppie.advisor.company?.companyName}}</p>
          <p>{{data_aiuppie.advisor.company?.locality}}</p>
        </div>

        <div *ngIf="data_aiuppie?.buyer">
          <h4>{{labels?.footer?.cliente}}</h4>
          <h5>{{data_aiuppie?.buyer?.name}} {{data_aiuppie?.buyer?.familyName}}</h5>
        </div>
      </div>
      <h5 class="contatti" *ngIf="data_aiuppie?.buyer?.urlProfile">{{labels?.footer?.info?.vaiAllaPagina}} <a
          href="{{data_aiuppie?.buyer?.urlProfile}}">{{labels?.footer?.info?.rivenditore}}</a>
        {{labels?.footer?.info?.oppureChiamaNumero}}</h5>
      <h5 class="contatti" *ngIf="data_aiuppie?.buyer === null || data_aiuppie?.buyer?.urlProfile === null">
        {{labels?.footer?.info?.chiamaNumero}}</h5>
    </div>

    <div class="footer-info-blocco">
      <h5>{{labels?.footer?.copyright}}</h5>
    </div>

  </div>


</section>